import { OrientationType } from "../../renderer/constant/RendererConstants";
import { AbstractViewProperties } from "../../view/properties/AbstractViewProperties";
/**
 * DialogProperties.ts
 */
export class DialogProperties extends AbstractViewProperties {
    constructor(position) {
        super(position);
        this.setDefaultValues();
    }
    setDefaultValues() {
    }
    getClass() {
        return null;
    }
    getClassName() {
        return null;
    }
    isDismissable() {
        return false;
    }
    getProperties(orientation) {
        return orientation === OrientationType.PORTRAIT ? this.portraitProperties : this.landscapeProperties;
    }
}
//# sourceMappingURL=DialogProperties.js.map